module.exports = __webpack_public_path__ + "img/icn_orderdetails.85f4e627.svg";